import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import { setShareData } from '@/utils/ShareUtil'
import config, { isTest } from '@/config'
Vue.use(Router)
const router = new Router({
    routes,
    mode: 'hash',
})
const appUrl = (isTest() ? config.appUrl.pro : config.appUrl.dev) + '/page/#'

router.beforeEach((to,from, next ) => {
    if (to.meta.title){
        document.title=to.meta.title;
    }
    if (to.query.inApp) {
        next();
        return;
    }
    if (from.query.inApp) {
        let toQuery = JSON.parse(JSON.stringify(to.query));
        toQuery.inApp = from.query.inApp;
        toQuery.statusBarH = from.query.statusBarH;
        next({
            path: to.path,
            query: toQuery
        })
    } else {
        next()
        setWxShareData(to)
    }
});

const setWxShareData = (to) => {
    const { path = '' } = to
    if (path === '/' || path.startsWith('/about')) {
        setShareData( {
            // 分享标题
            title: path === '/' ? '关于翡翠王朝' : `翡翠王朝${to.meta.title || ''}`,
            // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            link: `${appUrl}${path}`,
            desc: path === '/' ? '关于翡翠王朝' : '打造数字经济时代最强大的珠宝玉石公司，在客户满意度、产业服务能力、伙伴成就感等方面追求极致',
            // 分享图标
            imgUrl: 'https://share.jaadee.net/h5/tjr/img/share.jpg',
            success: function () {
                // 用户确认分享后执行的回调函数
            },
            cancel: function () {
                // 用户取消分享后执行的回调函数
            },
        })
    }
}
export default router;
